

//import Vue from 'vue'
export default function (event) {
   // console.log("i come from registerClickEventHandler.js class:name" + event.target.className)

   event.preventDefault()
   event.stopPropagation()

   if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('chronik'))) {


        //set referring target for browser back link!
        this.setBrowserBackLink(event.target.id) 

       if(typeof event.target.dataset.bd === 'undefined') {

           let fol = (event.target.dataset.f == null) ? -1 : event.target.dataset.f
           let target = (event.target.dataset.name == null) ? '' :  event.target.dataset.name
           let tz = event.target.dataset.tz

           let archiveItem = {
           tz: tz,
           imgIndex: 0,
           txtPageNr: fol,
           txtJumpTarget: target,
           originator: "sgggedankenfuge",
           txtSetFlag: true,
           changeArchive: true
           }
           this.$store.commit('updateArchiveItem', archiveItem)

           this.$nextTick(() => { 
                   this.$router.push({ name: 'archiv' ,    
                   params: {tzRouter: tz , fol: fol, target: target,  origin: 'seggedankenfuge' } }).catch(err => {})
           })
       }else {         
            let vol =  (event.target.dataset.bd == null) ? '' : event.target.dataset.bd
            //let target = (event.target.dataset.name == null) ? '' :  event.target.dataset.name
            let target = (event.target.dataset.sd == null) ? '' :  event.target.dataset.sd

            setTimeout(() => {
            this.$router.push({ 
                name: 'text', 
                //hash: "#"+target,
                hash: "#page-"+vol+"-"+target,
                params: {vol: vol} },() => {})            
            }, 200) 
       }
   }else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('extern'))) {
        //let url = event.target.getAttribute("href")
        let url =  (event.target.dataset.href == null) ? '' :  event.target.dataset.href
        this.setBrowserBackLink(event.target.parentNode.id)
        if (url.indexOf("http") == 0 ) {
            window.open(url, '_blank');
        }else {   
            const tempUrl = url.replace(/^\/+/g, '');
            this.$router.push('/' + tempUrl)
        }
    } 
    else if (event.target && (event.target.classList.contains('verweis') && event.target.classList.contains('ton'))) {

        const target = event.target.dataset.href
    
        //set referring target for browser back link!
        this.setBrowserBackLink(event.target.id) 
    
        this.$router.push({ 
          name: 'tondokumente', 
          //hash: "#"+target,
          params: {type: 'sound', id: target} }).catch(err => {});
      }

}
